import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
interface CartProps {
  /** Mobile variant shows only the icon + badge (no "Cart" label). */
  variant?: 'desktop' | 'mobile';
  /** Number of items currently in the cart. */
  count?: number;
}
/**
 * Cart trigger. Wired to the platform's native cart UI on import, so this
 * stays a real <button> rather than a link.
 */
export function Cart({
  variant = 'desktop',
  count = 0
}: CartProps) {
  const isMobile = variant === 'mobile';
  return <button type="button" className={isMobile ? 'text-gray-600 relative' : 'text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-2 text-sm font-semibold relative'} aria-label="Cart" data-id="element-66">
      <ShoppingCartIcon className={isMobile ? 'w-6 h-6' : 'w-5 h-5'} data-id="element-67" />
      <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center" data-id="element-68">
        {count}
      </span>
      {!isMobile && <span data-id="element-69">Cart</span>}
    </button>;
}